import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import set from 'lodash.set';

import { avatarUpload } from 'api/request';
import { sendResetPasswordEmail } from 'api/auth';
import { updateProfile } from 'api/users';
import { UserContext } from 'contexts/user';
import DesktopProfileInputs from 'components/profile_inputs/desktop';
import StripeInfo from 'components/stripe_info';
import useWindowDimensions, {
  isMobileResolution,
} from 'helpers/useWindowDimensions';
import MobileProfileInputs from 'components/profile_inputs/mobile';
import IntellioWarning from 'components/intelio_warning/intellio';

const Profile = ({ history }) => {
  const { user, setUser } = useContext(UserContext);
  const [localUser, setLocalUser] = useState(user);
  const [files, setFiles] = useState(null);
  const [validation, setValidation] = useState({
    firstName: true,
    lastName: true,
  });

  const { width } = useWindowDimensions();
  const isMobile = isMobileResolution(width);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setLocalUser({
      ...localUser,
      [name]: value,
    });
  };

  const handleFileUpload = async (files) => {
    setFiles(files);
  };

  const checkValidity = () => {
    const newValidation = {
      firstName: !!localUser.firstName,
      lastName: !!localUser.lastName,
    };

    setValidation(newValidation);

    return Object.values(newValidation).every(Boolean);
  };

  const handleSubmit = async () => {
    if (checkValidity()) {
      if (files) {
        const { path } = await avatarUpload('s3/upload', files[0].file);
        localUser.avatarUrl = path;
      }

      await updateProfile(localUser);

      const updatedUser = set(user, `${user.role}`, localUser);

      setUser(updatedUser);

      history.push('/profile');
    } else {
      window.scrollTo(0, 0);
    }
  };

  const handleResetPassword = async () =>
    await sendResetPasswordEmail({ email: user.email });

  const inputProps = {
    user: localUser,
    avatar: user.avatar,
    validation,
    onChange: handleChange,
    onFileUpload: handleFileUpload,
  };

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header post-header">
          <h2 className="th-canvas-title" data-test-screen-title>
            <Link to="/profile" className="active">
              {isMobile ? 'Profile' : 'My Profile'}
            </Link>
          </h2>
          <section className="view-actions">
            <button className="mr5 btn-white" onClick={handleResetPassword}>
              Reset password
            </button>
            <button className="btn-green" onClick={handleSubmit}>
              Save
            </button>
          </section>
        </header>
        <section className="view-container">
          {user.type !== 'non-sleep' && (
            <div
              className="flex flex-column mt10 mb10 gap4"
              style={{ gap: '16px' }}
            >
              <div className="w-100">
                <StripeInfo user={user} />
              </div>
              <div className="w-100">
                <IntellioWarning user={user} />
              </div>
            </div>
          )}
          {!isMobile && <DesktopProfileInputs {...inputProps} />}
          {isMobile && <MobileProfileInputs {...inputProps} />}
        </section>
      </section>
    </main>
  );
};

Profile.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default Profile;
